export default "__VITE_ASSET__CrMszGHC__"